import { Component, OnInit } from '@angular/core';
import { CourseRepositoryService } from '../../../courses/services/course-repository.service';
import { StudentCourseEntity } from '../../../../meta-data/app-meta-data.service';
import { CourseProgressItem } from '../../../courses/models/course-progress-hierarchy.model';
import IntegrationRepositoryService from '../../../integration/services/integration-repository.service';

@Component({
  selector: 'app-main-dashboard',
  templateUrl: './main-dashboard.component.html',
  styleUrls: ['./main-dashboard.component.scss']
})
export class MainDashboardComponent implements OnInit {
  studentCourses: StudentCourseEntity[];
  currentStudentCourse: StudentCourseEntity;
  currentCourseProgress: CourseProgressItem;

  readonly DashboardSections = DashboardSections;
  
  courseProgressFilters: any = {};

  setupComplete: boolean = false;
  showProgress: boolean = false;

  sectionLoading: { [prop:string]: boolean } = {};
  message: any;

  constructor(protected courseRepositoryService: CourseRepositoryService, protected integrationRepositoryService: IntegrationRepositoryService) { }

  ngOnInit(): void {
    this.sectionLoading[DashboardSections.courseProgress] = true;
    this.sectionLoading[DashboardSections.myCourses] = true;
    this.sectionLoading[DashboardSections.myAssignments] = true;

    this.setupDashboard();

    this.integrationRepositoryService.homePageIntegrationMessage.subscribe((message) => { 
      this.message = message;
    });
  }

  dataLoadComplete(section: DashboardSections) {
    //return;

    setTimeout(() => {
      
      this.sectionLoading[section] = false;
    }, 400);
  }

  setupDashboard() {

    this.courseRepositoryService.getCurrentStudentCourses()
      .subscribe((studentCourses) => {
        this.studentCourses = studentCourses;

        this.setupCurrentCourse();
      });
  }

  setupCurrentCourse() {
    this.currentStudentCourse = this.studentCourses?.find((studentCourse) => !studentCourse.CourseEndorsementStudent?.CourseEndorsementId);

    if (this.currentStudentCourse?.NextCourseLessonId) {
      this.currentStudentCourse.CourseIdDisplay;
        this.courseProgressFilters = {
          CourseLessonId: this.currentStudentCourse.NextCourseLessonId
        }

        this.showProgress = true;
    }

    this.setupComplete = true;

    return;

    // this.courseRepositoryService.getCourseProgress(this.currentStudentCourse.CourseId)
    //   .subscribe((courseProgress) => {
    //     this.currentCourseProgress = courseProgress;

    //     const courseLessonId = this.currentCourseProgress.furtherestLesson?.CourseLessonId || this.currentCourseProgress.modules[0]?.lessons[0]?.lesson?.CourseLessonId;

    //     if (!courseLessonId) {
    //       this.currentCourseProgress = null;
    //       return;
    //     }

    //     this.courseProgressFilters = {
    //       CourseLessonId : courseLessonId
    //     }

    //   }
    // );
  }
}


export enum DashboardSections {
  courseProgress = 'courseProgress',
  myCourses = 'myCourses',
  myAssignments = 'myAssignments'
}